import { render } from "./MediaComponent.vue?vue&type=template&id=320da7c4"
import script from "./MediaComponent.vue?vue&type=script&lang=js"
export * from "./MediaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__